import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CandidateService } from 'src/app/services/candidate.service';
import { FileStorageService } from 'src/app/services/file-storage.service';

@Component({
  selector: 'app-candidates-admin',
  imports: [CommonModule, RouterModule],
  templateUrl: './candidates-admin.component.html',
  styles: ``
})
export class CandidatesAdminComponent implements OnInit{
  showFilters: boolean = false;

  constructor(
      private CandidateService: CandidateService,
      private fileStorage: FileStorageService,
  ) { // Inject the candidatesService here    
    }

  candidatesList: any[] = [];
  candidatesListFiltered: any[] = [];

  ngOnInit(): void {
    this.getcandidates();
  }

  showFilter(): void {
    this.showFilters = !this.showFilters;
  }

  getcandidates(){
    this.CandidateService.getCandidate().subscribe({
      next: (res: any) => {
        this.candidatesList = res.map((item: any) => {
          return {
            ...item,
            file: item.photoFileId ? this.fileStorage.getFileUrl(item.photoFileId) : null
          };
        });
        this.candidatesListFiltered = res.map((item: any) => {
          return {
            ...item,
            file: item.photoFileId ? this.fileStorage.getFileUrl(item.photoFileId) : null
          };
        });              
      }
    });
  };
}
